import loadable from '@loadable/component';

export const AsyncLoanConfirm = loadable(() => import('./LoanConfirm'));
